import React, { Component } from 'react';
import MainStore from '../../../MainStore';
import { WorkPressureReport } from './WorkPressureReport';
import ReportBlock from './ReportBlock';
import { AllProjectsCosts } from './AllProjectsCosts';
import { EffectivityReport } from './EffectivityReport';
import { ProjectDistributionReport } from './ProjectDistributionReport';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AnalyticsProjectReport } from './AnalyticsProjectReport';
import { AnalyticsProjectPieReport } from './AnalyticsProjectPieReport';
import { AnalyticProjectTypeReport } from './AnalyticProjectTypeReport';
import { PeopleCosts } from './PeopleCosts';
import { MonthReport } from './MonthReport';
import { ExtendedHierarchicalReport } from './ExtendedHierarchicalReport';

export default class ReportBoard extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            peoples: [],
            costs: []
        };

        //this.load = this.load.bind(this);
    }

    componentDidMount() {
        //this.load();
    }

    load() {
        var scope = this;
        scope.setState({ loading: true });
        fetch('api/Report', {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ peoples: result, loading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        return (
            <div>

                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5a-content"
                        id="panel5a-header"
                    >
                        <div>Стоимости проектов</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="report-big-block">
                            <AllProjectsCosts />
                        </div>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6a-content"
                        id="panel6a-header"
                    >
                        <div>Распределение проектов по КВ</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <AnalyticsProjectReport />
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6a-content"
                        id="panel6a-header"
                    >
                        <div>Распределение типов проектов по КВ</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <AnalyticProjectTypeReport />
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6a-content"
                        id="panel6a-header"
                    >
                        <div>Analytical Pie</div>
                    </AccordionSummary>
                    <AccordionDetails>
                         <ReportBlock><AnalyticsProjectPieReport /></ReportBlock>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6a-content"
                        id="panel6a-header"
                    >
                        <div>КВ. Трудозатраты</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <ReportBlock><PeopleCosts /></ReportBlock>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6a-content"
                        id="panel6a-header"
                    >
                        <div>Месячный отчет</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <ReportBlock>
                            <MonthReport />
                        </ReportBlock>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6a-content"
                        id="panel6a-header"
                    >
                        <div>Расширенный отчет</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div>
                            <ExtendedHierarchicalReport />
                        </div>
                    </AccordionDetails>
                </Accordion>
                
            </div>);
    }
}